<template>
  <!-- <div id="showset">
    <h4 style="margin-top: 0px">路况显示</h4>
    <RadioGroup v-model="lukuangModel" @on-change="setLukuang">
      <Radio :label="1">显示</Radio>
      <Radio :label="2">不显示</Radio>
    </RadioGroup>
    <h4>卫星云图显示</h4>
    <RadioGroup v-model="yuntuModel" @on-change="setYun">
      <Radio :label="1">显示</Radio>
      <Radio :label="2">不显示</Radio>
    </RadioGroup>
    <h4>标注点显示</h4>
    <RadioGroup v-model="pointModel" @on-change="setPoint">
      <Radio :label="1">显示</Radio>
      <Radio :label="2">不显示</Radio>
    </RadioGroup>
    <h4>路线显示</h4>
    <RadioGroup v-model="lineModel" @on-change="setLine">
      <Radio :label="1">显示</Radio>
      <Radio :label="2">不显示</Radio>
    </RadioGroup>
    <h4>围栏显示</h4>
    <RadioGroup v-model="fenceModel" @on-change="setFence">
      <Radio :label="1">显示</Radio>
      <Radio :label="2">不显示</Radio>
    </RadioGroup>
    <p style="margin-top: 30px" v-if="false">
      <Button type="primary" long @click="save">保存设置</Button>
    </p>
  </div> -->
  <ul id="mapRightTop">
    <li @click="setLukuang" :class="{ active: lukuangModel }">
      <Icon type="ios-analytics-outline" />
      <p>路况</p>
    </li>
    <li @click="setYun" :class="{ active: yuntuModel }">
      <Icon type="ios-globe-outline" />
      <p>云图</p>
    </li>
    <li @click="setPoint" :class="{ active: pointModel }">
      <Icon type="ios-pin-outline" />
      <p>标注</p>
    </li>
    <li @click="setLine" :class="{ active: lineModel }">
      <Icon type="ios-pulse" />
      <p>路线</p>
    </li>
    <li @click="setFence" :class="{ active: fenceModel }">
      <Icon type="ios-ionic" />
      <p>围栏</p>
    </li>
  </ul>
</template>
<script>
import axios from "axios";
var AllRuleRouteId = [];
var AllRulePointId = [];
var AllRuleFenceId = [];
export default {
  data() {
    return {
      lukuangModel: false,
      yuntuModel: false,
      pointModel: false,
      lineModel: false,
      fenceModel: false,
      routes: [],
      showRuleRouteId: [],
      points: [],
      showRulePointId: [],
      fences: [],
      showRuleFenceId: [],
    };
  },
  methods: {
    getListFence() {
      axios({
        method: "post",
        url: axios.serverWeb + "/ruleRoute/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        var data = res.data.data.dataList;
        for (const i in data) {
          AllRuleRouteId.push(data[i].ruleRouteId);
        }
        this.routes = data;
        this.setLine();
        //console.log(this.routes);
      });
    },
    getPointList() {
      axios({
        method: "post",
        url: axios.serverWeb + "/rulePoint/list",
        data: {
          keyword: this.keyword,
        },
      }).then((res) => {
        var data = res.data.data.dataList;
        for (const i in data) {
          AllRulePointId.push(data[i].rulePointId);
        }
        this.points = data;
        this.setPoint();
      });
    },
    getFenceList() {
      axios({
        method: "post",
        url: axios.serverWeb + "/ruleFence/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        var data = res.data.data.dataList;
        for (const i in data) {
          AllRuleFenceId.push(data[i].ruleFenceId);
        }
        this.fences = data;
        this.setFence();
      });
    },
    save() {
      //保存this.showRuleRouteId
    },
    setLine() {
      this.lineModel=!this.lineModel;
      if (this.lineModel) {
        this.showRuleRouteId = AllRuleRouteId;
      } else {
        this.showRuleRouteId = [];
      }
      var arr = [];
      for (const i in this.routes) {
        if (this.showRuleRouteId.includes(this.routes[i].ruleRouteId)) {
          arr.push(this.routes[i]);
        }
      }
      this.$emit("lineData", arr);
    },
    setPoint() {
      this.pointModel=!this.pointModel;
      if (this.pointModel) {
        this.showRulePointId = AllRulePointId;
      } else {
        this.showRulePointId = [];
      }
      var arr = [];
      for (const i in this.points) {
        if (this.showRulePointId.includes(this.points[i].rulePointId)) {
          arr.push(this.points[i]);
        }
      }
      this.$emit("pointData", arr);
    },
    setFence() {
      this.fenceModel=!this.fenceModel;
      if (this.fenceModel) {
        this.showRuleFenceId = AllRuleFenceId;
      } else {
        this.showRuleFenceId = [];
      }
      var arr = [];
      for (const i in this.fences) {
        if (this.showRuleFenceId.includes(this.fences[i].ruleFenceId)) {
          arr.push(this.fences[i]);
        }
      }
      this.$emit("fenceData", arr);
    },
    setYun(v) {
      this.yuntuModel = !this.yuntuModel;
      this.$emit("yun", this.yuntuModel);
    },
    setLukuang(v) {
      this.lukuangModel = !this.lukuangModel;
      this.$emit("lukuang", this.lukuangModel);
    },
  },
  mounted() {
    this.getListFence();
    this.getPointList();
    this.getFenceList();
  },
};
</script>
<style lang="">
#showset h4 {
  margin-top: 20px;
  margin-bottom: 10px;
}
#lymap #mapRightTop {
  width: 34px;
  position: absolute;
  z-index: 20;
  top: 10px;
  left: 14px;
  text-align: center;
}
#lymap #mapRightTop li {
  background: rgba(255, 255, 255, 0.8);
  color: #555;
  margin-bottom: 15px;
  padding: 2px 0;
  border-radius: 4px;
}
#lymap #mapRightTop li i {
  font-size: 20px;
  margin-bottom: 0;
  line-height: 1;
}
#lymap #mapRightTop li p {
  font-size: 12px;
  margin-top: 0px;
  line-height: 1;
}
#lymap #mapRightTop li.active {
  color: #2aa3f3;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/showSet.vue